// @ts-expect-error
import 'swiper/css/pagination'
import { useRef } from 'react'
import { isEmpty } from 'remeda'
import { Navigation, Pagination, type Swiper } from 'swiper'
import { SwiperSlide } from 'swiper/react'
import { buildIntrinsicWidthSources } from '@velasca/utils/build-intrinsic-width-sources'
import { setQueryParams } from '@velasca/utils/set-query-params'
import { MaxWidthContainer } from '../MaxWidthContainer/MaxWidthContainer'
import { ParagraphCompositionWithCta } from '../ParagraphCompositionWithCta/ParagraphCompositionWithCta'
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Background,
  Card,
  Image,
  ImageContainer,
  Layout,
  NavigationButton,
  Slider,
  Text,
} from './CollectionFocusBlock.styles'
import type { CollectionFocusBlockProps } from './CollectionFocusBlock.types'

export const CollectionFocusBlock = ({
  slides,
}: CollectionFocusBlockProps): JSX.Element | null => {
  const swiperRef = useRef<Swiper>()

  if (!slides || isEmpty(slides)) {
    return null
  }

  return (
    <Background>
      <MaxWidthContainer>
        <Layout>
          {slides.length > 1 && (
            <NavigationButton onClick={() => swiperRef.current?.slidePrev()}>
              <ArrowLeftIcon />
            </NavigationButton>
          )}
          <Slider
            centeredSlides
            loop={slides.length > 1}
            navigation={slides.length > 1}
            modules={[Pagination, Navigation]}
            pagination={{
              clickable: true,
            }}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper
            }}
          >
            {slides.map(
              ({ id, image, upperTitle, title, description, cta }) => {
                return (
                  <SwiperSlide key={id}>
                    <Card isSingleSlide={slides.length === 1}>
                      {image && (
                        <ImageContainer>
                          <Image
                            lqip
                            lazyload
                            alt={image.alt}
                            sources={buildIntrinsicWidthSources({
                              src: image.src,
                            })}
                            imgSrc={setQueryParams(image.src, [
                              { name: 'width', value: '30' },
                            ])}
                          />
                        </ImageContainer>
                      )}
                      <Text>
                        <ParagraphCompositionWithCta
                          upperTitle={upperTitle}
                          title={title}
                          description={description}
                          cta={cta}
                        />
                      </Text>
                    </Card>
                  </SwiperSlide>
                )
              },
            )}
          </Slider>
          {slides.length > 1 && (
            <NavigationButton onClick={() => swiperRef.current?.slideNext()}>
              <ArrowRightIcon />
            </NavigationButton>
          )}
        </Layout>
      </MaxWidthContainer>
    </Background>
  )
}
